import React, { createContext, useContext, useEffect, useState } from 'react';
import { ref, get } from 'firebase/database';
import { auth, database } from 'src/book/src/firebase';
import { useParams } from 'react-router';
import { onAuthStateChanged, setPersistence, browserLocalPersistence } from 'firebase/auth';

const AuthShopContext = createContext();

export const AuthShopProvider = ({ children }) => {
  const [bizId, setBizId] = useState(null);
  const [bizPhoneNumber, setBizPhoneNumber] = useState(null);

  const { businessName } = useParams();

  const [businessInfo, setBusinessInfo] = useState(null);

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBizInfo = async () => {
      try {
        const dbRef = ref(database, `/biz/userInfo/${bizId}`);
        const snapshot = await get(dbRef);

        if (snapshot.exists()) {
          setBusinessInfo(snapshot.val());
        } else {
        }
      } catch (error) {
        console.error(error);
      }
    };

    // Whenever bizId changes, update localStorage

    if (bizId !== null) {
      fetchBizInfo();
    }
  }, [bizId]);

  // const businessName = 'barberiaMenCare';

  useEffect(() => {
    const fetchBusinessData = async () => {
      try {
        const dbRef = ref(database, `/biz/publicMappings/${businessName}`);
        // const dbRef = ref(database, `/biz/publicMappings/barberiaMenCare`);

        const snapshot = await get(dbRef);

        if (snapshot.exists()) {
          const val = snapshot.val();
          setBizId(val.id);
          setBizPhoneNumber(val.number);
          // setData(snapshot.val());
          // scheduleManager = new ScheduleManager(snapshot.val(), language);
        } else {
          console.log('No data available');
        }
      } catch (error) {
        console.error(error);
      }
    };

    if (businessName) {
      fetchBusinessData();
    }
  }, [businessName]);

  const isAHLamasat = () => {
    return (
      bizId === '7ed2d810-d356-422f-9fc5-bc201e66116c' ||
      bizId === '0c51e037-e539-405e-99d5-64a7738df09f'
    );
  };

  useEffect(() => {
    let unsubscribe;

    const initAuth = async () => {
      try {
        // Set persistence to LOCAL
        await setPersistence(auth, browserLocalPersistence);

        unsubscribe = onAuthStateChanged(auth, async (user) => {
          // console.log('Auth state changed:', user?.uid);
          if (user) {
            try {
              await user.getIdToken(true);
              setUser(user);
            } catch (error) {
              // console.error('Token refresh failed:', error);
              setUser(null);
            }
          } else {
            setUser(null);
          }
          setLoading(false);
        });
      } catch (error) {
        console.error('Error setting persistence:', error);
        setLoading(false);
      }
    };

    initAuth();

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);

  return (
    <AuthShopContext.Provider
      value={{
        bizId,
        bizPhoneNumber,
        businessInfo,
        isAHLamasat,
        user,
        loading,
      }}
    >
      {children}
    </AuthShopContext.Provider>
  );
};

export const useAuthShop = () => {
  const context = useContext(AuthShopContext);
  return context || {};
};
